import { render } from "./app.vue?vue&type=template&id=80f24ed2"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=80f24ed2&lang=scss"

import exportComponent from "/Users/colorful/Desktop/work/java/acetale/acetale-mina/acetale-mini-cms-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__